module.exports = "\n<div>\n    <queue-modal v-ref:queue-modal></queue-modal>\n    <form-visit-scheduling v-ref:scheduling :on-create=\"visitCreated\"\n                           :on-update=\"visitUpdated\"></form-visit-scheduling>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/javascript/components/Bus.vue
// module id = ./node_modules/vue-html-loader/index.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/javascript/components/Bus.vue
// module chunks = 54